const Theme = {
  body_background_image_url: 'savoureaston.png',
  header_full_height: true,

  logo_image_url: 'savoureaston.png',

  token_url: 'savoureaston.png',
  number_hidden: true,
  token_hidden: true,

  button_color: '#588a6b',
  button_border_width: 1,
  button_text_weight: 500,
  button_hover_color: 'white',
  button_hover_text_color: '#588a6b',
  button_hover_border_color: '#588a6b',
  button_outlined_color: 'white',
  button_outlined_text_color: '#588a6b',
  button_outlined_hover_color: '#588a6b',
  button_outlined_hover_text_color: 'white',

  button_half_text_weight: 500,
  button_half_text_size: 14,

  separator_style: 'dotted',
  separator_color: '#588a6b',
  separator_height: 2,

  text_color: '#020549',
  font_color: '#020549',
  title_color: '#020549',
  subtitle_color: '#020549',

  text_font: `'Roboto Condensed Light', sans-serif`,
  text_size: 14,
  text_lineheight: 18,

  title_font: `'Lobster', sans-serif`,
  title_weight: 500,
  title_size: 30,
  title_lineheight: 33,

  subtitle_font: `'Lobster', sans-serif`,
  subtitle_size: 24,
  subtitle_lineheight: 28,
  subtitle_weight: 500,

  footer_border_color: '#eee',

  photobooth_background_color: 'black',
  photobooth_button_text_color: 'white',
  photobooth_title_color: 'white',
  photobooth_button_color: '#588a6b',
}

export default Theme
